import { useLanguage } from '@/hooks/useLanguage';
import { tx as translateInterfaceText } from '@/utils/i18n';
export function useDomainValidation(existingDomains: string[]) {
  useLanguage();
  const normalizeDomain = (input: string): string => {
    let normalized = input.trim().toLowerCase();
    
    // Remove protocolo
    normalized = normalized.replace(/^(https?:\/\/)?(www\.)?/, '');
    
    // Remove caminhos e querystring
    normalized = normalized.split('/')[0].split('?')[0];
    
    // Colapsa pontos duplicados
    normalized = normalized.replace(/\.{2,}/g, '.');
    
    return normalized;
  };

  const isRootDomain = (domain: string): boolean => {
    const pattern = /^([a-z0-9-]+\.)+[a-z]{2,}$/;
    return pattern.test(domain);
  };

  const isWildcard = (domain: string): boolean => {
    const pattern = /^\*\.([a-z0-9-]+\.)+[a-z]{2,}$/;
    return pattern.test(domain);
  };

  const validate = (domain: string): string | null => {
    if (!domain) return null;

    const normalized = normalizeDomain(domain);

    // Verifica duplicidade
    if (existingDomains.map(d => d.toLowerCase()).includes(normalized)) {
      return translateInterfaceText("Domínio já cadastrado.");
    }

    // Valida wildcard
    if (normalized.startsWith('*.')) {
      if (!isWildcard(normalized)) {
        return translateInterfaceText("Wildcard inválido. Use *.seudominio.com.");
      }
      return null;
    }

    // Valida domínio raiz
    if (!isRootDomain(normalized)) {
      return translateInterfaceText("Formato inválido. Use algo como seudominio.com.br.");
    }

    return null;
  };

  return {
    normalizeDomain,
    isRootDomain,
    isWildcard,
    validate
  };
}
